import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import * as EgovNet from 'api/fetch';
import { getSessionItem } from 'utils/storage';

import ReactQuill from "react-quill-new";
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill'
import QuillResizeImage from 'quill-resize-image';

import "styles/scss/NnewSubmit.scss";

// Quill에 이미지 리사이즈 모듈 등록
Quill.register("modules/resize", QuillResizeImage);

function PostEdit() {
    const checkRef = useRef([]);
    const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
    const sessionUser = getSessionItem('loginUser');
    const sessionUserId = sessionUser?.id;
    const [isEditMode, setIsEditMode] = useState(false);
    const [isRegType, setIsRegType] = useState(''); // CT01: 비지니스, CT02: N소식, CT03:보도자료, CT04:갤러리
    const [files, setFiles] = useState([]);
    const [html, setHtml] = useState('');
    const [bizTtl, setBizTtl] = useState('');
    const contentRef = useRef(null);
    const [ctgryList, setCtgryList] = useState([]);
    const [bizseList, setBizseList] = useState([]);
    const { pstId } = useParams(); // URL 파라미터로 ID 가져오기
    const [fileLength, setFileLength] = useState(5);
    const [bizNmReadOnly, setBizNmReadOnly] = useState(false);

    const [detail, setDetail] = useState({ 
        pstId: "",
        ctgry: "",
        bizSe: "",
        bizNm: "",
        pstTtl: "",
        lnkgAddr: "",
        pstCn: "",
        bizYrPrd: "",
        atchFileId: "",
        regId: sessionUserId,
        //현재일자 시분(YYYY-MM-DD HH:MM)
        regDt: new Date().toISOString().slice(0, 16).replace("T", " "),
        useYn: "Y",
        thumbnailUrl: ""
    });    

    const navigator = useNavigate();

    useEffect(() => {     
        if(pstId !== undefined) {
            detailPst(pstId);
            setIsEditMode(true); // 수정 모드 활성화
        } else {
            editSetting();
            setIsEditMode(false);
        }
    }, []);

    const uploadedImages = useRef([]);

    const imageHandler = () => {
        // 비지니스 및 보도자료는 이미지 1개만 업로드 가능
        // if (isRegType === "CT01" || isRegType === "CT03") {
        //     if (uploadedImages.current.length >= 1) {
        //         alert("비지니스 및 보도자료는 이미지 1개만 업로드 가능합니다.");
        //         return;
        //     }
        // } 
        const input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", "image/*");
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if (!file) return;
            
            try {        
                //이미지는 폼데이터로 전송
                const formData = new FormData();
                formData.append('image', file);

                // 서버로 이미지 업로드 요청을 보내고 이미지 URL을 받아옵니다.
                const retrieveListURL = "/api/image/upload";
                const requestOptions = {
                    method: "POST",
                    body: formData,
                };

                EgovNet.requestFetch(
                    retrieveListURL,
                    requestOptions,
                    (resp) => {
                        // 업로드된 이미지의 URL을 가져옵니다.
                        const imageUrl = resp.imageUrl; // 서버에서 반환된 이미지 URL
                        uploadedImages.current.push(imageUrl);
                        
                        const editor = contentRef.current.getEditor(); // ReactQuill의 Quill 인스턴스를 가져옵니다.
                        const range = editor.getSelection(); // 현재 선택된 범위를 가져옵니다.
                        
                        if (range) {
                            editor.insertEmbed(range.index, "image", imageUrl); // 이미지 삽입
                            editor.setSelection(range.index + 1); // 커서를 이미지 뒤로 이동
                        }
                        handleHtmlChange(editor.root.innerHTML); // HTML 내용 업데이트
                        setDetail((prevDetail) => ({
                            ...prevDetail,
                            thumbnailUrl: resp.thumbnailUrl // HTML 내용 업데이트
                        }));
                    },
                    (errorResp) => {
                        alert("이미지 업로드 중 오류가 발생했습니다." + errorResp);
                    }
                );
            } catch (error) {
                alert("이미지 업로드 중 오류가 발생했습니다.");
            }
        };
    }

    const formats = [
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "align",
        "image"
    ];

    const modules = useMemo(() => ({
        toolbar: { 
            container: [
                [{ size: [] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ list: 'ordered' }, { align: [] }],
                ['image'],
            ],
            handlers: {
                image: imageHandler, // 이미지 핸들러 등록
            },

        }
    }), []);

    const modules2 = useMemo(() => ({
        toolbar: { 
            container: [
                ['clean']
            ]
        }
    }), []);

    const editSetting = () => {
        const retrieveListURL = '/api/pst';
        const requestOptions = {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
            }
        }
        EgovNet.requestFetch(retrieveListURL,
            requestOptions,
            (resp) => {
                setCtgryList(resp.result.ctgry.resultList);
                setBizseList(resp.result.bizse.resultList);
            },
            (resp) => {
                console.log("err response : ", resp);
            }
        );
    }

    const detailPst = (id) => {
        const retrieveDetailURL = `/api/pst/${id}`;
        const requestOptions = {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
            }
        }
        EgovNet.requestFetch(retrieveDetailURL,
            requestOptions,
            function (resp) {
                setCtgryList(resp.result.ctgry.resultList);
                setBizseList(resp.result.bizse.resultList);
                setDetail(resp.result.pst);
                setFiles(resp.result.fileList || []); // 기존 파일 목록 설정  
                setHtml(resp.result.pst.pstCn);
                setBizTtl(resp.result.pst.bizNm);
                changeAttribute(resp.result.pst.ctgry);
                setIsRegType(resp.result.pst.ctgry); // 게시글 분류 설정
            },
            (resp) => {
                console.log("err response : ", resp);
            }
        );
    };

    const handleRegBtn = () => {
        if(files.length > 0) {
            handleUpload();
        } else {
            createPst();
        }
    }

    // 파일 업로드
    const handleUpload = async () => {
        const formData = new FormData();    
        // 파일 추가
        files.forEach((file) => {
            formData.append("files", file);
        });
        try {
            const retrieveListURL = '/api/file/upload';
            const requestOptions = {
                method: "POST",
                body: formData
            }
            EgovNet.requestFetch(retrieveListURL,
                requestOptions,
                (resp) => {
                    const newFileId = resp.result.atchFileId; // 서버에서 반환된 fileId
                    setDetail((prevDetail) => ({
                        ...prevDetail,
                        atchFileId: newFileId,
                    }));
                    createPst(); // 파일 업로드 후 게시글 등록
                },
                (resp) => {
                    console.log("err response : ", resp);
                }
            );
        } catch (error) {
            alert("파일 업로드 중 오류가 발생했습니다.");
        }
    };

    const createPst = () => {
        const formData = new FormData();
        for (let key in detail) {
            formData.append(key, detail[key]);
        }
        if (formValidator(formData)) {
            const retrieveURL = `/api/pst`;
            const requestOptions = {
                method: "POST",
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify({ ...detail })
            };
            EgovNet.requestFetch(retrieveURL,
                requestOptions,
                (resp) => {
                    if (Number(resp.resultCode) === 200) {
                        alert('등록이 완료되었습니다.');
                        navigator('/psts'); // 등록 후 목록으로 이동
                    } else {                        
                        alert('등록에 실패하였습니다.');
                    }
                }
            );
            cleanForm();
        }
    }

    const formValidator = (formData) => {
        if (formData.get('ctgry') === null || formData.get('ctgry') === "") {
            alert("게시글 분류는 필수 선택입니다.");
            return false;
        }
        if (formData.get('pstTtl') === null || formData.get('pstTtl') === "") {
            alert("제목은 필수 값입니다.");
            return false;
        }
        if (formData.get('pstCn') === null || formData.get('pstCn') === "") {
            alert("내용은 필수 값입니다.");
            return false;
        }
        return true;
    };

    // 파일 수정
    const handleUploadUpdate = async () => {
        const formData = new FormData();    
        // 파일 추가
        files.forEach((file) => {
            formData.append("files", file);
        });
        try {
            const retrieveListURL = `/api/file/update/${pstId}`;
            const requestOptions = {
                method: "PUT",                
                body: formData
            };
            EgovNet.requestFetch(retrieveListURL,
                requestOptions,
                (resp) => {
                    const newFileId = resp.result.atchFileId; // 서버에서 반환된 fileId
                    setDetail((prevDetail) => ({
                        ...prevDetail,
                        atchFileId: newFileId,
                    }));
                    updatePst(newFileId); // 파일 업로드 후 게시글 등록
                },
                (resp) => {
                    console.log("err response : ", resp);
                }
            );
        } catch (error) {
            alert("파일 업로드 중 오류가 발생했습니다.");
        }
    };    

    const updatePst = (atchFileId) => {
        if (formObjValidator(checkRef)) {
            const retrieveURL = `/api/pst/${atchFileId}`;
            const requestOptions = {
                method: "PUT",
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify({ ...detail })
            };
            EgovNet.requestFetch(retrieveURL,
                requestOptions,
                (resp) => {
                    if (Number(resp.resultCode) === 200) {
                        alert('수정이 완료되었습니다.');
                        navigator('/psts');
                    } else {
                        alert('수정에 실패하였습니다.');
                    }
                }
            );
            cleanForm();
        }
    }

    const formObjValidator = (checkRef) => {
        if (checkRef.current[0].value === "") {
            alert("게시글 분류는 필수 선택입니다.");
            return false;
        }
        if (checkRef.current[1].value === "") {
            alert("제목은 필수 값입니다.");
            return false;
        }
        if (checkRef.current[1].value === "") {
            alert("내용은 필수 값입니다.");
            return false;
        }
        return true;
    };
    
    const cleanForm = () => {
        setDetail('');
    }

    const handleCtgryChange = (e) => {
        const selectedValue = e.target.value;
        const selectedName = e.target.options[e.target.selectedIndex].text; // 선택된 분류명
        
        setDetail({...detail, ctgry: selectedValue, ctgryNm: selectedName, uploadFile: "" });
        setIsRegType(selectedValue);
        changeAttribute(selectedValue); // 분류에 따라 속성 변경
    }

    const changeAttribute = (selectedValue) => {
        // 게시글 분류에 따른 비활성화 처리
        // 각 항목들 속성 가져오기
        const bizSe = document.getElementById("bizSe");
        const bizYrPrd = document.getElementById("bizYrPrd");
        const bizNm = document.getElementById("bizNm");
        const lnkgAddr = document.getElementById("lnkgAddr");
        const upload = document.getElementById("uploadFile");

        // CT01: 비지니스, CT02: N소식, CT03:보도자료, CT04:갤러리
        if (selectedValue === "CT02" || selectedValue === "CT04") {
            setBizTtl("");
            setDetail((prevDetail) => ({...prevDetail, bizSe: "", bizYrPrd: "", lnkgAddr: "", bizNm: ""}));
            if (bizSe) bizSe.disabled = true;
            if (bizYrPrd) bizYrPrd.disabled = true;
            if (lnkgAddr) lnkgAddr.disabled = true;
            if (upload) upload.disabled = false;
            setBizNmReadOnly(true); // bizNm을 읽기 전용으로 설정
        } else if (selectedValue === "CT01") {
            setDetail((prevDetail) => ({...prevDetail, lnkgAddr: "", uploadFile: ""}));
            if (bizSe) bizSe.disabled = false;
            if (bizYrPrd) bizYrPrd.disabled = false;
            if (lnkgAddr) lnkgAddr.disabled = true;
            if (upload) upload.disabled = true;
            setBizNmReadOnly(false); // bizNm을 읽기 전용으로 설정
        } else if (selectedValue === "CT03") {
            setBizTtl("");
            setDetail((prevDetail) => ({...prevDetail, bizSe: "", bizYrPrd: "", uploadFile: "", bizNm: ""}));
            if (bizSe) bizSe.disabled = true;
            if (bizYrPrd) bizYrPrd.disabled = true;
            if (lnkgAddr) lnkgAddr.disabled = false;
            if (upload) upload.disabled = true;
            setBizNmReadOnly(true); // bizNm을 읽기 전용으로 설정
        }
    }

    const handleBizSeChange = (e) => {
        const selectedValue = e.target.value;
        const selectedName = e.target.options[e.target.selectedIndex].text;

        setDetail({...detail, bizSe: selectedValue, bizSeNm: selectedName });
    }

    const handleHtmlChange = (e) => {
        setHtml(e);
        detail.pstCn = e;
    }

    const handleTitleChange = (e) => {
        setBizTtl(e);
        detail.bizNm = e;
    }

    const handleFileChange = (e) => {
        if(files.length > fileLength - 1) {
            alert("파일은" + fileLength + "개만 등록 가능합니다.");
            return;
        }

        const selectedFiles = Array.from(e.target.files); // 선택된 파일들을 배열로 변환
        
        // 중복 파일 제거
        const uniqueFiles = selectedFiles.filter(
            (newFile) => !files.some((existingFile) => existingFile.name === newFile.name)
        );

        setFiles((prevFiles) => [...prevFiles, ...uniqueFiles]); // 기존 파일에 새 파일 추가
    }

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index)); // 선택된 파일 삭제
    }
    
    const handleListBtn = () => {
        navigator('/psts'); // 목록으로 이동
    }

    const handleModifyBtn = () => {
        if(files.length > 0) {
            handleUploadUpdate();
        } else {
            updatePst(); // 파일이 없을 경우 바로 수정
        }
    }    

    const handleResetBtn = () => {
        // 화면 재로딩
        window.location.reload();
    }

    const handleReplyBtn = () => {
        //화면 새로고침
        window.location.reload();
    }

    const handleDeleteBtn = () => {
        const confirm = window.confirm("삭제하시겠습니까?");
        if (confirm) {
            const retrieveDetailURL = `/api/pst`;
            let requestOptions = {
                method: 'DELETE',
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify({ ...detail })
            }
            EgovNet.requestFetch(retrieveDetailURL,
                requestOptions,
                (resp) => {
                    if (Number(resp.resultCode) === 200) {
                        alert('삭제되었습니다.');
                        navigator('/psts'); // 삭제 후 목록으로 이동
                    } else {
                        alert('삭제에 실패하였습니다.');
                    }
                }
            );
            cleanForm();
        } else {
            alert('취소되었습니다.');
            return;
        }
    }

    return (
        <>
            <div className="news-background">
                <h1>게시글관리</h1>
                <p>[ 비지니스 / N소식 ]</p>
                {/* 브레드크럼 */}
                <div className="breadcrumb-box container">
                <nav className="breadcrumb">
                    <ul>
                        <li className="home-icon">
                        <Link to="/">
                            <span className="home"></span>
                        </Link>
                        </li>
                        <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                            게시글관리
                            <span className="dropdown-icon">
                                {isCompanyDropdownOpen ? "▲" : "▼"}
                            </span>
                            {isCompanyDropdownOpen && (
                            <ul className="dropdown-menu">
                                <li>
                                    <Link to="/about">회사소개</Link>
                                </li>
                                <li>
                                    <Link to="/business">비즈니스</Link>
                                </li>
                                <li>
                                    <Link to="/news">N소식</Link>
                                </li>
                                <li>
                                    <Link to="/recruitment">인재채용</Link>
                                </li>
                            </ul>
                            )}
                        </li>
                    </ul>
                </nav>
                <div className="mobile">
                    <ul>
                        <li className="home-icon">
                            <Link to="/">
                                <span className="home"></span>
                            </Link>
                        </li>
                        <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                            N소식
                            <span className="dropdown-icon">
                                {isCompanyDropdownOpen ? "▲" : "▼"}
                            </span>
                            {isCompanyDropdownOpen && (
                            <ul className="dropdown-menu">
                                <li>
                                    <Link to="/about">회사소개</Link>
                                </li>
                                <li>
                                    <Link to="/business">비즈니스</Link>
                                </li>
                                <li>
                                    <Link to="/news">N소식</Link>
                                </li>
                                <li>
                                    <Link to="/recruitment">인재채용</Link>
                                </li>
                            </ul>
                            )}
                        </li>
                    </ul>
                </div>
                </div>
            </div>
            <div className="container submit-box">
                <ul>
                    <li className='tit'>
                        <h3 className="sub-tit">{isEditMode? "수정하기" : "등록하기"}</h3>
                    </li>
                    <li>
                        <div className='form-label required'>는 필수입력 항목입니다.</div>
                    </li>
                    <li>
                        <div className="Submit-group">
                            {/* row01 */}
                            <div className="form-row row-flex select-box">
                                <div>
                                    <div className="form-label required">게시글분류</div>
                                    <select className="form-control form-select select"
                                        id="ctgry" name="ctgry"
                                        value={detail.ctgry || ''}
                                        onChange={handleCtgryChange}
                                        ref={(el) => (checkRef.current[0] = el)}
                                    >
                                        <option value="">선택</option>
                                        {ctgryList.map((option, i) => {
                                            return (
                                            <option value={option.ctgry} key={i}>{option.ctgryNm}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                            {/* row02 */}
                            {(isRegType !== "CT02" && isRegType !== "CT03" && isRegType !== "CT04") &&
                            <div className="form-row row-flex">
                                <div>
                                    <div className="form-label required">사업구분</div>
                                    <select className="form-control form-select select"
                                        id="bizSe" name="bizSe"
                                        value={detail.bizSe || ''}
                                        onChange={handleBizSeChange}
                                        maxLength={30}
                                    >
                                        <option value="">선택</option>
                                        {bizseList.map((option, i) => {
                                            return (
                                            <option value={option.bizSe} key={i}>{option.bizSeNm}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div>
                                    <div className="form-label required">사업연도(기간)</div>
                                    <div className="form-input border-bottom-none">
                                        <input type="text" name="bizYrPrd" id="bizYrPrd"
                                            className="form-control"
                                            value={detail.bizYrPrd || ''}                                            
                                            placeholder="사업연도(기간)을 입력해주세요."
                                            maxLength={20}
                                            onChange={(e) => setDetail({ ...detail, bizYrPrd: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                            }
                            {/* row03 */}
                            {(isRegType !== "CT02" && isRegType !== "CT03" && isRegType !== "CT04") &&
                            <div className="form-row">
                                <div className="form-label required">사업명</div>
                                <ReactQuill theme="snow"
                                    className="form-input form-txt"
                                    modules={modules2}
                                    readOnly={bizNmReadOnly} // 상태에 따라 읽기 전용 설정
                                    name="bizNm" id="bizNm"
                                    value={bizTtl || ''}
                                    onChange={handleTitleChange}
                                    placeholder='한줄에 최대 15자까지 포현됩니다.'
                                />
                            </div>
                            }
                            {/* row04 */}
                            <div className="form-row row-flex">
                                <div>
                                    <div className="form-label required">제목</div>
                                    <div className="form-input">
                                        <input type="text" name="pstTtl" id="pstTtl"
                                            className="form-control"
                                            placeholder="제목을 입력해주세요."
                                            value={detail.pstTtl || ''}
                                            onChange={(e) => setDetail({ ...detail, pstTtl: e.target.value })}
                                            maxLength={50}
                                            ref={(el) => (checkRef.current[1] = el)}
                                        />
                                    </div>
                                </div>
                                {(isRegType !== "CT02" && isRegType !== "CT03" && isRegType !== "CT04") &&
                                <div>
                                    <div className="form-label required">url</div>
                                    <div className="form-input">
                                        <input type="url" name="lnkgAddr" id="lnkgAddr"
                                            className="form-control"
                                            placeholder="링크URL"
                                            value={detail.lnkgAddr || ''}
                                            onChange={(e) => setDetail({ ...detail, lnkgAddr: e.target.value })}
                                            maxLength={100}
                                        />
                                    </div>
                                </div>
                                }
                            </div>
                            {/* row05 */}
                            <div className="form-row">
                                <div className="form-label required">내용</div>
                                <ReactQuill theme="snow"
                                    className="form-input form-txt"
                                    name="pstCn" id="pstCn"
                                    formats={formats} modules={modules}
                                    value={html || ''}
                                    ref={(el) => {
                                        checkRef.current[2] = el;
                                        contentRef.current = el;
                                    }}
                                    onChange={handleHtmlChange}
                                />
                            </div>
                            {/* row06 */}
                            {(isRegType !== "CT01" && isRegType !== "CT03") &&
                            <div className="form-row">
                                <div className="form-label">첨부파일</div>
                                <div className="form-input">
                                    <input type="file" name="uploadFile" id="uploadFile"
                                        className="form-control"
                                        onChange={handleFileChange} // 파일 선택 시 호출되는 함수
                                    />
                                </div>
                                <ul>
                                    {files.map((file, index) => (
                                        // 파일 이름 표시
                                        // 삭제 버튼 추가
                                        <li key={index} className='fileList-box'>
                                            {file.orignlFileNm || file.name}
                                            <button type="button" className=' btn delete-btn' onClick={() => handleDeleteFile(index)}>
                                                <span className='delete-img'></span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            }
                        </div>
                        <div className="btn-group">
                            <div>
                                <button type="button" className="btn btn-list" onClick={handleListBtn}>목록</button>
                            </div>
                            {!isEditMode &&
                            <div className="btn-group-flex">
                                <button type="button" className="btn btn-delete" onClick={handleResetBtn}>취소</button>
                                <button type="button" className="btn btn-submit" onClick={handleRegBtn}>등록</button>
                            </div>
                            }
                            {isEditMode &&
                            <div className="btn-group-flex">
                                <button type="button" className="btn btn-edit" onClick={handleModifyBtn}>수정</button>
                                <button type="button" className="btn btn-submit" onClick={handleReplyBtn}>취소</button>
                                <button type="button" className="btn btn-delete" onClick={handleDeleteBtn}>삭제</button>
                            </div>
                            }
                        </div>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default PostEdit;